<template>
  <section>
    <!-- 使用记录 -->
    <div class="pop-room car-edit-pop" v-if="logStatus">
      <a href="javascript:;" @click="$emit('hideLog')" class="iconfont icon-close"></a>
      <h3 class="title" style="padding-bottom:6px;">
        {{ logCar.plateNo+" - "+ logCar.xh}}
        <el-button plain type="success" style="margin: 0 0 0 30px;" size="mini" @click="addLog()">添加新日志</el-button>
      </h3>

      <el-table :data="paginationData" style="width: 100%" v-loading="loading">
        <!-- <el-table-column width="130px" prop="driveTime" label="日期" >
        </el-table-column> -->

        <el-table-column label="出发时间 - 返回时间" width="250">
          <template slot-scope="scope">
            {{ scope.row.startTime+' - '+ scope.row.endTime}}
          </template>
        </el-table-column>

        <el-table-column prop="name" label="项目名/目的地"></el-table-column>

        <el-table-column label="驾驶员" width="140">
          <template slot-scope="scope">
            <user-info :userData='scope.row.driver'></user-info>
          </template>
        </el-table-column>
        <el-table-column prop="oil" label="加油记录" width="100"></el-table-column>
        <el-table-column prop="xn" label="车辆性能" width="70"></el-table-column>
        <el-table-column label="操作" width="50">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑该日志" placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editCarLogBtnClick(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>


      </el-table>
    </div>

    <!-- 添加/编辑日志 -->
    <div class="pop-room " v-if="addLogStatus">
      <a href="javascript:;" @click="addLogStatus=false" class="iconfont icon-close"></a>
      <h3 class="title" style="padding-bottom:6px;margin-bottom:-10px;">
        添加/编辑新日志
      </h3>
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="120px" class="form">
          <el-form-item label="日期">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="form.driveTime" type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="出发时间">
            <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.startTime" type="datetime"
              placeholder="出发时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="返回时间">
            <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm:ss" v-model="form.endTime" type="datetime"
              placeholder="返回时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="项目名称/目的地">
            <el-input size="small" v-model="form.name" placeholder="请输入项目名称/目的地"></el-input>
          </el-form-item>
          <el-form-item label="驾驶员">
            <div class="contact-user-list">
              <div class="user-item" v-for="user,i in selectLeader">
                <span class="name">{{user.name}}</span>
              </div>
            </div>
            <el-button @click="addUsers()" size="mini" type="primary">选择人员</el-button>
          </el-form-item>
          <el-form-item label="加油记录">
            <el-input size="small" v-model="form.oil" placeholder="加油记录"></el-input>
          </el-form-item>
          <el-form-item label="车辆性能">
            <el-select @change="forceUpdate" size="small" v-model="form.xn" placeholder="请选择">
              <el-option v-for="item in xnType" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-button @click="addBtnClick()" class="form-btn" type="success">确认提交</el-button>
          </el-form-item>

        </el-form>
      </el-col>

    </div>

  </section>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['logStatus', 'logCar', 'userData'],
    components: {
      UserInfo,
    },
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        // 添加/编辑日志
        addLogStatus: false,
        xnType: ['优秀', '正常', '差'],
        // form: {},
        form: {
          carId: '',
          depId: '',
          driveTime: '',
          driverId: '',
          startTime: '',
          endTime: '',
          oil: '',
          name: '',
          xn: '',
          json: true,
        },
        selectLeader: "",

        loading: true,

        // 印章使用/外带记录
        logData: '',

        tabType: 0,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    created() {
      if (this.logSealId) {
        // 获取列表
        this.getLists()
      }
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      editCarLogBtnClick(row) {
        this.addLogStatus = true
        this.form = row
        this.form.recordId = row.id
        this.form.carId = row.car.id
        this.form.depId = row.department.id
        this.form.driverId = row.driver.id
        this.selectLeader = [row.driver]
        this.form.json = true
      },
      addBtnClick() {
        this.addLogStatus = false
        let _url = this.form.recordId ? '/car/drive/record/edit?recordId=' + this.form.recordId :
          '/car/drive/record/add'
        ajax.post(_url, this.form, (res) => {
          // 获取列表
          this.getLists()
        })
      },
      // 新建编辑日志
      addLog() {
        this.selectLeader = ''
        this.form = {
          carId: '',
          driveTime: '',
          driverId: '',
          startTime: '',
          endTime: '',
          oil: '',
          name: '',
          xn: '',
          json: true,
        }
        this.form.depId = this.userData.secDepIds.split(",")[0] / 1
        this.form.carId = this.logCar.id
        this.addLogStatus = true
      },
      // 添加驾驶员
      addUsers() {
        let _sr = this.selectLeader
        this.$store.commit('set_contactSelectArr', _sr)
        this.$store.commit('set_contactApprovalItem', false)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', true)

        setTimeout(() => {
          this.selectType = 3
        }, 500)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.sealName.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 ||
              _item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        let _url = "/car/drive/record/" + this.logCar.id

        ajax.get(_url, "", (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'logCar.id'() {
        this.getLists()
      },
      contactSelectArr() {
        this.selectLeader = this.contactSelectArr
      },
      selectLeader() {
        this.form.driverId = this.selectLeader[0] ? this.selectLeader[0].id : ''
      },
    }

  }
</script>


// WEBPACK FOOTER //
// src/page/car/log.vue